function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicGAppClose = function SvgIcLogicGAppClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: 0,
    y: 0,
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10669",
    d: "m16.6 15 5.6-5.6c.4-.4.4-1.1 0-1.6-.4-.4-1.1-.4-1.5 0L15 13.5 9.4 7.9c-.4-.5-1.1-.5-1.5 0-.5.4-.5 1.1 0 1.5l5.6 5.6-5.6 5.6c-.4.4-.4 1.1 0 1.5.2.2.5.3.8.3s.6-.1.8-.3l5.6-5.6 5.6 5.6c.2.2.5.3.8.3s.6-.1.8-.3c.4-.4.4-1.1 0-1.5z",
    style: {
      fill: "#c1c1c1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_20730",
    d: "M0 0h30v30H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgIcLogicGAppClose;